<template>
  <div>
    <div class='pt-2 altura-250 tab-ficha'>
      <div class='d-flex align-center'>
        <!-- <img
          class='btn-generico'
          :src='require("@/assets/images/Btn-arrowLeft.gif")'
          :alt="$t('lang.comun.anterior')"
          @click='restarMes()'
        />
        <div class='calendario-mes'>{{ month + ' ' + year }}</div>
        <img
          class='btn-generico'
          :src='require("@/assets/images/Btn-arrowRight.gif")'
          :alt="$t('lang.comun.anterior')"
          @click='sumarMes()'
        /> -->
         <div class="col-sm-1 col-md-1">
          <button type="button"  class="vuecal__arrow vuecal__arrow--prev" @click='restarMes()'>
            &nbsp;<i alt="Anterior" class="angle"></i>&nbsp;
          </button>
        </div>
        
          <div class='d-flex align-center'>
              <div class="titulo-mes">{{ month + ' ' + year }}</div>
              <v-btn type="button" class="primary" @click="irHoy">HOY</v-btn>
          </div>
        
        <div class="text-left col-sm-1 col-md-1">
          <button type="button" aria-label="Next month" class="float-right vuecal__arrow vuecal__arrow--next" @click='sumarMes()'>&nbsp;<i class="angle"></i>&nbsp;</button>
        </div>
      </div>
      <div class='calendario-body mt-2 noselect'>
        <div class="calendario-semana">
            <strong class='calendario-dia-semana' v-for='day in days' :key='day'>{{ day }}</strong>
        </div>
        <div class='calendario-dias'>
          <div class='calendario-dias-fila' v-for='semana in calendario' :key='semana.indiceSemana'>
            <div
              class='calendario-dias-fila-celda'
              v-for='dia in semana.diasSemana'
              :key='dia.diaNumber'
              :class='{ deshabilitado : dia.diaTipo === 0, findesemana: dia.diaTipo === 2, vacaciones: dia.diaTipo === 3, festivo: dia.diaTipo === 4, hoy : dia.hoy }'
              @click="showModal(dia, month ,year)"
            >
              <b-row>
                <b-col sm='4'>
                  <div class='calendario-dias-fila-celda-dia'>
                    {{ dia.diaNumber }}
                  </div>
                </b-col>
                <b-col sm='6' class='p-0'>
                  <div
                    class='calendario-dias-fila-celda-duracion pr-1 pointer'
                    v-if='dia.duracionMs !== 0'
                    :class='{ duracionCorrecta : dia.jornadaCorrecta, duracionIncorrecta : !dia.jornadaCorrecta}'>
                    {{ dia.duracionHoras }}
                    <div
                      class='calendario-dias-fila-celda-duracion-jornada'
                      v-if='dia.duracionMs !== 0'>
                      {{ dia.duracionJornada }}
                    </div>  
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </div>
      <DetalleFichaje 
        :dialog="dialog"
        :dia="dia"
        :fecha="fecha"
        @close="closeModal()" ></DetalleFichaje>        
  </div>
</template>
<script>
import { CalenlabApiService } from '@/api/CalenlabApiService'
import { FichajeApiService } from '@/api/FichajeApiService'
import { JornadaApiService } from '@/api/JornadaApiService'
import { HorariodiaApiService } from '@/api/HorariodiaApiService'
import { Util } from '@/api/Util'

import DetalleFichaje from '@/components/DetalleFichaje.vue'

const calenlabApiService = new CalenlabApiService()
const fichajeApiService = new FichajeApiService()
const jornadaApiService = new JornadaApiService()
const horariodiaApiService = new HorariodiaApiService()
const util = new Util()
const moment = require('moment')

export default {
  data () {
    return {
      dialog: false,
      today: moment(),
      dateContext: moment(),
      lang: sessionStorage.getItem('lang'),
      calendarioLaboral: [],
      fichaje: [],
      opuid: this.$store.getters.getOpuid,
      duracionJornada: 25200000,
      days: [
        this.$t('lang.calendario.lun'),
        this.$t('lang.calendario.mar'),
        this.$t('lang.calendario.mie'),
        this.$t('lang.calendario.jue'),
        this.$t('lang.calendario.vie'),
        this.$t('lang.calendario.sab'),
        this.$t('lang.calendario.dom')
      ],
      personaJornada: [],
      horariodia: [],
      dia: {},
      fecha: ''
    }
  },
  components: {
    DetalleFichaje
  },
  props: {
    personaParam: Object,
    tabSeleccionado: Number
  },
  mounted () {
    this.init()
  },
  watch: {
    personaParam: {
      handler (n, o) {
        if (n.mspersonaid !== o.mspersonaid) {
          this.reset(n)
        }
      },
      deep: true
    },
    year: {
      handler (n, o) {
        if (n !== o) {
          // Cargamos el calendario laboral de ese anho
          this.getDiatrabajoByAnhoAndOpuid()
        }
      },
      deep: true
    },
    month: {
      handler (n, o) {
        if (n !== o) {
          this.getFichajeByAnhoMesAndPersonaId()
          this.getPersonajornadaByFechaAndPersonaUid()
        }
      },
      deep: true
    },
    personaJornada: {
      handler (n, o) {
        if (n !== o) {
          this.getHorariodiaByJornadaId()
        }
      },
      deep: true
    }
  },
  methods: {
    init () {
      moment.locale(this.lang)
      this.today = moment()
      this.dateContext = moment()
      this.getFichajeByAnhoMesAndPersonaId()
      // if (sessionStorage.getItem('opUid')) {
      //   // Parseamos la persona almacenada en session
      //   this.opuid = sessionStorage.getItem('opUid')
      // }
      this.getDiatrabajoByAnhoAndOpuid()
      this.getPersonajornadaByFechaAndPersonaUid()
    },
    showModal (dia, month, year) {
      if (dia.duracionMs !== 0) {
        this.dia = dia
        this.fecha = dia.diaNumber + ' ' + month + ' ' + year
        this.dialog = true
      }
    },
    closeModal () {
      this.dialog = false
    },
    reset () {
      this.today = moment()
      this.dateContext = moment()
      this.getFichajeByAnhoMesAndPersonaId()
      this.getDiatrabajoByAnhoAndOpuid()
    },
    sumarMes: function () {
      this.dateContext = moment(this.dateContext).add(1, 'month')
    },
    restarMes: function () {
      this.dateContext = moment(this.dateContext).subtract(1, 'month')
    },
    irHoy () {
       this.dateContext = moment(this.dateContext).set('month', moment().month())
    },
    getDiatrabajoByAnhoAndOpuid () {
      if (this.year && this.opuid) {
        calenlabApiService.getDiatrabajoByAnhoAndOpuid(this.year, this.opuid)
          .then(data => {
            util.mostrarEnConsola('PersonasTabFichajes - getDiatrabajoByAnhoAndOpuid', data.length, 'OK')
            this.calendarioLaboral = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabFichajes - getDiatrabajoByAnhoAndOpuid', error, 'ERROR')
          })
      }
    },
    getFichajeByAnhoMesAndPersonaId () {
      if (this.year && this.personaParam) {
        fichajeApiService.getFichajeByAnhoMesAndPersonaId(this.year, this.mesSimple, this.personaParam.mspersonaid)
          .then(data => {
            util.mostrarEnConsola('PersonasTabFichajes - getFichajeByAnhoMesAndPersonaId', data.length, 'OK')
            this.fichaje = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabFichajes - getFichajeByAnhoMesAndPersonaId', error, 'ERROR')
          })
      }
    },
    checkDia: function (dia, mes, anho) {
      var diaObj = {
        diaNumber: null,
        diaStr: '',
        diaTipo: 0,
        duracionMs: 0,
        duracionHoras: '0:00'
      }
      if (dia && mes && anho) {
        var fecha = moment(dia + '-' + mes + '-' + anho, 'DD-MMM-YYYY')
        if (this.isFestivo(fecha)) { // Comprobamos si es festivo
          diaObj.diaNumber = dia
          diaObj.diaStr = String(dia)
          diaObj.diaTipo = 4
        }
        else if (moment(fecha).day() === 0) { // Fin de semana
          diaObj.diaNumber = dia
          diaObj.diaStr = String(dia)
          diaObj.diaTipo = 2
        } else { // Todo lo demas
          diaObj.diaNumber = dia
          diaObj.diaStr = String(dia)
          diaObj.diaTipo = 1
        }
        if (moment(fecha).isSame(new Date(), 'day')) { // Comprobamos si es hoy
          diaObj.hoy = true
        }
        // Comprobamos el fichaje
        // var duracion = this.getDuracionFichaje(fecha)
        var fichaje = this.getFichaje(fecha)
        var duracion = this.getDuracionFichaje(fichaje)

        diaObj.duracionMs = duracion.duracionMs
        diaObj.duracionHoras = duracion.duracionHoras
        diaObj.fichaje = fichaje
        // Obtenemos la duracion de la jornada
        let duracionJor = 0
        if (this.horariodia.length) {
          for (let i = 0; i < this.horariodia.length; i++) {
            const horariodiaItem = this.horariodia[i]
            if (horariodiaItem.mshorariodiadiasemana === fecha.day()) {
              if (horariodiaItem.mshorariodiafin1 && horariodiaItem.mshorariodiainicio1) {
                duracionJor += moment.duration(moment(horariodiaItem.mshorariodiafin1, 'hh:mm').diff(moment(horariodiaItem.mshorariodiainicio1, 'hh:mm')))
              }
              if (horariodiaItem.mshorariodiafin2 && horariodiaItem.mshorariodiainicio2) {
                duracionJor += moment.duration(moment(horariodiaItem.mshorariodiafin2, 'hh:mm').diff(moment(horariodiaItem.mshorariodiainicio2, 'hh:mm')))
              }
              diaObj.duracionJornada = util.convertirMilisegundoAHoras(duracionJor, 2)
              diaObj.horario = horariodiaItem.mshorariodiainicio1 + '-' + horariodiaItem.mshorariodiafin1 
              if (horariodiaItem.mshorariodiainicio2 !== null && horariodiaItem.mshorariodiafin2 !== null)
                diaObj.horario += ' / ' + horariodiaItem.mshorariodiainicio2 + '-' + horariodiaItem.mshorariodiafin2
              diaObj.tipoJornada = horariodiaItem.jornada.msjornadadesc
            }
          }
        }
        if (diaObj.duracionMs > duracionJor) {
          diaObj.jornadaCorrecta = true
        } else {
          diaObj.jornadaCorrecta = false
        }
      }
      return diaObj
    },
    getFichaje (fecha) {
      let fichajeAux = []
      if (this.fichaje.length > 0) {
        for (let i = 0; i < this.fichaje.length; i++) {
          if (moment(fecha).isSame(this.fichaje[i].msfichajefecha)) {
            fichajeAux.push(this.fichaje[i])
          }
        }
      }
      return fichajeAux
    },
    getDuracionFichaje (fichaje) {
      var total = {duracionMs: 0, duracionHoras: '0:00'}
      var duracion = 0
      var count = 0
      var horaAux = 0
      if (fichaje.length > 0) {
        for (let i = 0; i < fichaje.length; i++) {
          const fichajeItem = fichaje[i]
          if ((fichajeItem.msfichajetipo !== 2 && fichajeItem.msfichajetipo !== 3) || i!==0) {
            if (count === 0) { // Guardamos la primera hora
              horaAux = fichajeItem.msfichajehora
              count++
            } else { // Obtenemos la duracion del intervalo en ms
              duracion += moment.duration(moment(fichajeItem.msfichajehora, 'hh:mm').diff(moment(horaAux, 'hh:mm')))
              count = 0
            }
          }
        }
      }
      if (duracion !== 0) {
        total.duracionMs = duracion
        total.duracionHoras = util.convertirMilisegundoAHoras(duracion, 2)
      }
      return total
    },
    getPersonajornadaByFechaAndPersonaUid () {
      if (this.personaParam) {
        jornadaApiService.getPersonajornadaByFechaAndPersonaUid(moment(this.dateContext).format('YYYY-MM-DD'), this.personaParam.mspersonauid)
          .then(data => {
            // console.log(data)
            util.mostrarEnConsola('PersonasTabFichajes - getPersonajornadaByFechaAndPersonaUid', data.length, 'OK')
            this.personaJornada = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabFichajes - getPersonajornadaByFechaAndPersonaUid', error, 'ERROR')
          })
      }
    },
    getHorariodiaByJornadaId () {
      if (this.personaJornada.length > 0) {
        horariodiaApiService.findAllHorariodia({ jornada: { msjornadaid: this.personaJornada[0].jornada.msjornadaid } })
          .then(data => {
            console.log(data)
            util.mostrarEnConsola('PersonasTabFichajes - getHorariodiaByJornadaId', data.length, 'OK')
            // Recorremos el array, sumamos totales y ponemos par
            let count = 0
            for (let i = 0; i < data.length; i++) {
              let horariodiaItem = data[i]
              let duracion = 0
              if (horariodiaItem.mshorariodiafin1 && horariodiaItem.mshorariodiainicio1) {
                duracion += moment.duration(moment(horariodiaItem.mshorariodiafin1, 'hh:mm').diff(moment(horariodiaItem.mshorariodiainicio1, 'hh:mm')))
              }
              if (horariodiaItem.mshorariodiafin2 && horariodiaItem.mshorariodiainicio2) {
                duracion += moment.duration(moment(horariodiaItem.mshorariodiafin2, 'hh:mm').diff(moment(horariodiaItem.mshorariodiainicio2, 'hh:mm')))
              }
              horariodiaItem.total = util.convertirMilisegundoAHoras(duracion, 1)
              if (count === 0) {
                horariodiaItem.diaPar = true
                count++
              } else {
                horariodiaItem.diaPar = false
                count = 0
              }
            }
            this.horariodia = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabFichajes - getHorariodiaByJornadaId', error, 'ERROR')
          })
      }
    },
    isFestivo (fecha) {
      if (this.calendarioLaboral.length > 0) {
        for (let i = 0; i < this.calendarioLaboral.length; i++) {
          const calendarioLaboralItem = this.calendarioLaboral[i]
          if (moment(fecha).isSame(calendarioLaboralItem.msdiatrabajofecha)) {
            if (calendarioLaboralItem.msdiatrabajotipo === 1 || calendarioLaboralItem.msdiatrabajotipo === 2 || calendarioLaboralItem.msdiatrabajotipo === 3 || calendarioLaboralItem.msdiatrabajotipo === 4) {
              return true
            }
          }
        }
        return false
      }
    }
  },
  computed: {
    year: function () {
      return this.dateContext.format('Y')
    },
    mes: function () {
      return this.dateContext.format('MM')
    },
    mesSimple: function () {
      return this.dateContext.format('M')
    },
    month: function () {
      return this.dateContext.format('MMMM')
    },
    daysInMonth: function () {
      return this.dateContext.daysInMonth()
    },
    currentDate: function () {
      return this.dateContext.get('date')
    },
    firstDayOfMonth: function () {
      var firstDay = moment(this.dateContext).subtract((this.currentDate - 1), 'days')
      return firstDay.weekday()
    },
    initialDate: function () {
      return this.today.get('date')
    },
    initialMonth: function () {
      return this.today.format('MMMM')
    },
    initialYear: function () {
      return this.today.format('Y')
    },
    weekOfMonth: function () { // Semana con respecto al mes
      return this.dateContext.week() - moment(this.dateContext).startOf('month').week() + 1
    },
    numberOfWeeksOfMonth: function () {
      const dateFirst = moment(this.dateContext).date(1)
      const dateLast = moment(this.dateContext).date(this.dateContext.daysInMonth())
      const startWeek = dateFirst.isoWeek()
      const endWeek = dateLast.isoWeek()
      if (endWeek < startWeek) {
        return (Math.abs(dateFirst.isoWeeksInYear() - startWeek) + endWeek) + 1
      } else {
        return endWeek - startWeek + 1
      }
    },
    calendario: function () {
      const calendario = []
      var d = 1
      for (var semana = 0; semana < this.numberOfWeeksOfMonth; semana++) {
        // Creamos los días de la semana
        if (semana === 0) { // Primera semana
          const semanaArray = {
            indiceSemana: semana,
            diasSemana: []
          }
          for (var x = 0; x < this.firstDayOfMonth; x++) {
            semanaArray.diasSemana.push(this.checkDia(null, this.month, this.year))
          }
          for (var l = this.firstDayOfMonth; l < 7; l++) {
            semanaArray.diasSemana.push(this.checkDia(d, this.month, this.year))
            d++
          }
          calendario.push(semanaArray)
        } else if (semana === this.numberOfWeeksOfMonth - 1) { // Ultima semana
          const semanaArray = {
            indiceSemana: semana,
            diasSemana: []
          }
          for (var i = 0; i < 7; i++) {
            if (d <= this.daysInMonth) {
              semanaArray.diasSemana.push(this.checkDia(d, this.month, this.year))
              d++
            } else {
              semanaArray.diasSemana.push(this.checkDia(null, this.month, this.year))
            }
          }
          calendario.push(semanaArray)
        } else { // Resto de semanas
          const semanaArray = {
            indiceSemana: semana,
            diasSemana: []
          }
          for (let j = 0; j < 7; j++) {
            semanaArray.diasSemana.push(this.checkDia(d, this.month, this.year))
            d++
          }
          calendario.push(semanaArray)
        }
      }
      // console.log(calendario)
      return calendario
    },
    duracionJornadaHora: function () {
      return util.convertirMilisegundoAHoras(this.duracionJornada, 2)
    }
  }
}
</script>
